import React from "react";
import { Card, Form, Select, Spin, Table, Typography } from "antd";
import { Icon } from "Components";
import { ColumnsType } from "antd/es/table";
import { MappingSetting } from "../Mapping";
import { useTranslation } from "react-i18next";

const { Title, Text } = Typography;

interface MappingTableContainerProps {
  selectedTenantId: string | null;
  isLoading: boolean;
  columns: ColumnsType<MappingSetting>;
  dataSource: MappingSetting[];
}

export const MappingTableContainer: React.FC<MappingTableContainerProps> = ({
  selectedTenantId,
  isLoading,
  columns,
  dataSource,
}) => {
  const { t } = useTranslation()

  return (
    <div className="bg-white pbx-24"
      style={{
        minHeight: "100vh",
        background: "white",
        padding: "24px"
      }}
    >
      <div className="mapping mw-1200 mx-auto">
        {/* Header Section */}
        <div className="mbx-24">
          <Title
            className="fs-15 card-foreground"
            level={3}
          >
            {t("mapping.mappingSettings.title")}
          </Title>
          <Text className="fs-1 text-muted-foreground fw-400">
            {t("mapping.mappingSettings.description")}
          </Text>
        </div>

        {/* Platform Mappings Table */}
        <Card
          className="platform-mappings-card"
          title={
            <h4 className="fs-1 card-foreground fw-400">
              {t("mapping.mappingSettings.platformMappings")}
            </h4>
          }
          bordered
        >
          {selectedTenantId ? (
            <Spin spinning={isLoading}>
              <Table
                columns={columns}
                dataSource={dataSource}
                pagination={false}
                rowKey="key"
              />
            </Spin>
          ) : (
            <div className="pt-3 pb-3 text-center">
              <Text
                type="secondary" className="fs-1 text-muted-foreground"
              >
                {t("mapping.mappingSettings.selectTenantMessage")}
              </Text>
            </div>
          )}
        </Card>
      </div>
    </div>
  );
};